import React from "react";
import { Modal, Button, Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { PRODUCT_NAME } from "../../product";

interface TrialModeModalProps {
    show: boolean;
    onHide: () => void;
}

/**
 * Modal that displays trial mode information and upgrade instructions.
 * Shows when users try to access paid features while in trial mode.
 */
const SUPPORT_MAIL = `mailto:support@sweap.io?subject=${encodeURIComponent(`Ich interessiere mich für den ${PRODUCT_NAME}`)}`;

const TrialModeModal: React.FC<TrialModeModalProps> = ({ show, onHide }) => {
    const { t } = useTranslation("common");

    const handleContactSupport = () => {
        window.open(SUPPORT_MAIL, "_blank");
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{t("trialMode.title")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert variant="warning" className="mb-3">
                    <Alert.Heading>{t("trialMode.heading")}</Alert.Heading>
                    <p className="mb-0">{t("trialMode.description")}</p>
                </Alert>

                <p>
                    {t("trialMode.contact")}{" "}
                    <a href={SUPPORT_MAIL} target="_blank">
                        support@sweap.io
                    </a>
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t("buttons.close")}
                </Button>
                <Button variant="primary" onClick={handleContactSupport}>
                    {t("trialMode.contactSupport")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TrialModeModal;
